import {
    Box,
    Flex,
    Button,
    Divider,
    Heading
} from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import "react-datepicker/dist/react-datepicker.css";
import LocationSelect from "./LocationSelect";
import PopularCategoriesSlider from "../PopularCategoriesSlider/PopularCategoriesSlider";
import MultiSearchInput from './MultiSearchInput';
import DateRangeFilter from "./DateRangeFilter";

const SearchHeader = ({
    events,
    categories,
    hashtags,
    onSelectionChange,
    dateRange,
    onDateChange,
    location,
    onLocationChange,
    onSearch,
    selectedTags = [] // Added prop with default value
}) => {
    const { t } = useTranslation("default");

    const handleCategoryClick = (category) => {
        const categoryTag = { ...category, type: 'Kategoria' };
        if (!selectedTags.some(tag => tag.id === categoryTag.id && tag.type === categoryTag.type)) {
            onSelectionChange([...selectedTags, categoryTag]);
        }
    };

    const handleSearch = () => {
        if (onSearch) {
            onSearch();
        }
    };

    return (
        <Flex alignItems={"center"} justifyContent="center" w={"100%"} flexDirection={'column'} bg={'surface.card'} px={{ base: '16px', md: '24px', '2xl': 0 }} pt={{ base: '16px', md: '32px' }} pb={{ base: '32px', md: '56px' }}>
            <Flex flexDirection={'column'} w="100%" maxW="7xl" alignItems={'flex-start'} bg={'brand.50'} borderRadius={{ base: '24px', md: '32px' }}
                  px={{ base: '18px', md: '64px' }} pt={{ base: '32px', md: '72px' }} pb={{ base: '24px', md: '48px' }} position="relative" overflow="hidden">
                <Box position="absolute" right={{ base: '-90px', md: '-80px' }} top={{ base: '-90px', md: '-120px' }} w={{ base: '220px', md: '420px' }} h={{ base: '220px', md: '420px' }} borderRadius="full" bg="#F2DCE2" aria-hidden="true" />
                <Box position="absolute" right="180px" bottom="-160px" w="280px" h="280px" borderRadius="full" bg="#F6D9C9" opacity={0.55} display={{ base: 'none', md: 'block' }} aria-hidden="true" />

                <Heading as="h1" position="relative" fontWeight={700} fontSize={{ base: '38px', md: '64px' }} lineHeight={1.03} letterSpacing={{ base: '-1px', md: '-2px' }} color='brand.700'>
                    {t('event.filter')}
                </Heading>
                {/* Form Filter */}
                <Flex
                    id="search-header"
                    flexDirection={{ base: 'column', md: 'row' }}
                    pt={{ base: '20px', md: '32px' }}
                    pb={{ base: '4px', md: 0 }}
                    position="relative"
                    rounded="none"
                    gap={{ base: '16px', md: '16px' }}
                    w="100%"
                >
                    <Flex gap={{ base: 0, md: 0 }} direction={{ base: 'column', md: 'row' }} w="100%" bg={"white"} borderRadius={{ base: '18px', md: '20px' }}
                          p={{ base: '6px', md: '8px' }} alignItems={{ base: 'stretch', md: 'center' }}
                          boxShadow="0 1px 2px rgba(14,26,23,0.05), 0 16px 40px rgba(58,15,27,0.10)">
                        <Flex 
                            bg={"white"} 
                            alignItems={{ base: 'stretch', md: 'center' }} 
                            fontFamily="body" 
                            fontWeight={'400'}
                            fontSize={'18px'} 
                            color={'ink.500'} 
                            alignSelf='center'
                            justifyContent={'center'} 
                            w="100%" 
                            flexDirection={{ base: 'column', md: 'row' }} 
                            px={0}
                            py={0}
                        >
                            <Box flex="1.5" minW="0" p={{ base: 2, md: 2 }} w="100%" display="flex" alignItems="center">
                                <MultiSearchInput
                                    events={events}
                                    categories={categories}
                                    hashtags={hashtags}
                                    onSelectionChange={onSelectionChange}
                                    selectedTags={selectedTags}
                                />
                            </Box>

                            <Box display={{ base: 'block', md: 'none' }} w="100%" px={2}>
                                <Divider borderColor="#F1EAEA" />
                            </Box>

                            <Box flex="0.5" p={{ base: 2, md: 2 }} borderRight={{ base: 'none', md: '1px solid #ECE4E4' }} borderLeft={{ base: 'none', md: '1px solid #ECE4E4' }} w="100%" display="flex" alignItems="center">
                                <DateRangeFilter
                                    dateRange={dateRange}
                                    onDateChange={onDateChange}
                                />
                            </Box>

                            <Box display={{ base: 'block', md: 'none' }} w="100%" px={2}>
                                <Divider borderColor="#F1EAEA" />
                            </Box>

                            <Box flex="1" p={{ base: 2, md: 2 }} w="100%" display="flex" alignItems="center">
                                <LocationSelect
                                    value={location}
                                    onChange={onLocationChange}
                                    t={t}
                                />
                            </Box>

                        </Flex>
                        
                        <Box w={{ base: "100%", md: "auto" }}>
                            <Button bg={'brand.500'} w={{ base: '100%', md: 'auto' }} px={'30px'} h={{ base: '52px', md: '60px' }} color={"white"} gap={'10px'}
                                fontWeight={'700'} fontSize={'16px'} mt={{ base: '6px', md: 0 }}
                                onClick={handleSearch} borderRadius={{ base: '13px', md: '14px' }}
                                _hover={{ bg: '#5C1628' }}
                            >
                                <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" mt={'3px'} ml={'4px'}>
                                    <path d="M10 9.75L13 12.75" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                    <path d="M6.25 10.75C8.87335 10.75 11 8.62335 11 6C11 3.37665 8.87335 1.25 6.25 1.25C3.62665 1.25 1.5 3.37665 1.5 6C1.5 8.62335 3.62665 10.75 6.25 10.75Z" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                                </svg>
                                {t('search')}
                            </Button>
                        </Box>
                    </Flex>
                </Flex>
                <Box w="100%" position="relative" mt={{ base: '20px', md: '32px' }}>
                    <PopularCategoriesSlider onCategorySelect={handleCategoryClick} />
                </Box>
            </Flex>
        </Flex>
    )
}

export default SearchHeader;
